import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { InsaCronService } from "../../../../../insa-services"
import { TaskActivityDetails } from "../../../../../insa-models";

@Component({
    selector: "edit-task-activity",
    template: require("./edit-task-activity-details.component.html")
})

export class EditTaskListActivityDetailsComponent implements OnInit{
    private today = new Date();
    private dueTimeDays: number = null;
    private dueTimeHours: number = null;
    private dueTimeSum: number = null;

    _activityID: any;
    _prioritiesList: Array<any>;

    @Input() editTaskActivityForm: FormGroup;
    @Input() set taskActivityDetails(taskActivityData: any){ this._activityID = taskActivityData; }
    @Input() set prioritiesList(pl: Array<Object>){ this._prioritiesList = pl; }

    taskActivityData: TaskActivityDetails = new TaskActivityDetails();  
    userAcc: any = [];
    //priorities: any;
    selectedUsers: number[] = [];

    constructor(private _insaChronosService: InsaCronService){}

    ngOnInit(){
        //this._insaChronosService.getPriorities().subscribe(p => this.priorities = p );
        this._insaChronosService.getUserAcc().subscribe((u: any) => this.userAcc = u);
        if(this._activityID !== undefined && this._activityID !== null){
            this._insaChronosService.getTaskActivityByID(this._activityID).subscribe((p: any) => {
                this.taskActivityData = p
                let dueTime = this.taskActivityData.DueTime;
                this.dueTimeDays = Math.trunc(dueTime / 24);
                this.dueTimeHours = dueTime - (this.dueTimeDays * 24);
                this.selectedUsers = this.taskActivityData.AssignedUserList;
            })
        }
    }

    dateTimeDaysChanged(dateTimeDays) {

        let hoursFinal = 24 * dateTimeDays + this.dueTimeHours;

        this.taskActivityData.DueTime = hoursFinal;
        console.log("duetime -> " + this.taskActivityData.DueTime);
    }

    dateTimeHoursChanged(dateTimeHours) {

        let hoursFinal = 24 * this.dueTimeDays + dateTimeHours;

        this.taskActivityData.DueTime = hoursFinal;
        console.log("duetime -> " + this.taskActivityData.DueTime);
    }

        toggleUser(userId: number, event: any) {
        if (event.target.checked) {
            this.selectedUsers.push(userId);
        } else {
            this.selectedUsers = this.selectedUsers.filter(id => id !== userId);
        }
        
        // Update the form control
        this.editTaskActivityForm.patchValue({
            Details: {
                AssignedUserList: this.selectedUsers
            }
        });
    }

    removeUser(userId: number) {
        this.selectedUsers = this.selectedUsers.filter(id => id !== userId);
        
        // Update the form control
        this.editTaskActivityForm.patchValue({
            Details: {
                AssignedUserList: this.selectedUsers
            }
        });
    }

    isSelected(userId: number): boolean {
        return this.selectedUsers.includes(userId);
    }

    getUserName(userId: number): string {
        const user = this.userAcc.find(u => u.ID === userId);
        return user ? user.FullName : '';
    }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-activities-detail/task-activity-details/edit-task-activity-details.component.ts